import { Grid, Hidden, makeStyles } from '@material-ui/core';
import React from 'react'

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	container: {
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
		display: 'flex',
		flexDirection: 'column',
	},
	userButton: {
		width: '140px',
		height: '140px',
		borderRadius: '70px',
		border: '5px solid',
		borderColor: '#1e88e5',
		padding: '0',
	},
	buttonText: {
		textAlign: 'center',
		margin: '10px 0',
		color: '#1e88e5',
	},
	buttonItem: {
		width: '140px',
		margin: 'auto',
	},
	buttonNavigator: {
		width: '100%',
		height: '140px',
		textDecoration: 'none',
		color: '#1e88e5',
	},
	userInfo: {
		height: '100px',
		marginTop: '-60px',
		background: '#3D2294',
		width: '100%',
		margin: '20px auto',
		color: '#FFF',
		borderRadius: '10px',
		fontWeight: 700,
		fontSize: '11px',
		lineHeight: '17px',
		textAlign: 'center',
	},
	mainHeader: {
		fontWeight: 700,
		fontSize: '15px',
		lineHeight: '23px',
		textAlign: 'center',
		color: '#3D2294',
	},
	mainContent: {
		background: '#fff',
		marginTop: '20px',
		borderRadius: '10px',
		height: '200px',
		paddingTop: '40px',
	},
	commingSoon: {
		display: 'inline-block',
		width: '94%',
		background: '#008D52',
		color: '#fff',
		position: 'relative',
		top: '-28px',
	},
	commingSoonMain: {
		display: 'inline-block',
		width: '100%',
		background: '#008D52',
		color: '#fff',
		position: 'relative',
		top: '-28px',
  },
	userInfoValue: {
		width: '50px',
		display: 'inline-block',
		height: '50px',
		margin: '0px 15px',
		fontWeight: 700,
		fontSize: '25px',
		lineHeight: '50px',
		background: '#644ea9',
		color: '#FFFFFF',
		boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
		borderRadius: '12px',
	}
}
))
const SubMenu: React.FC<any> = () => {
	const classes = useStyles()

	return (
		<>
			<Hidden mdDown>
				<Grid container className={classes.userInfo} id="user_info">
					<Grid item xs={3} style={{ textAlign: 'center' }}>
						<span style={{ lineHeight: '100px', textAlign: 'center' }}>درخواست های ثبت شده :</span>
						<span className={classes.userInfoValue}>0</span>
					</Grid>
					<Grid item xs={3} style={{ textAlign: 'center' }}>
						<span style={{ lineHeight: '100px', textAlign: 'center' }}>درخواست های به نتیجه رسیده :</span>
						<span className={classes.userInfoValue}>0</span>
					</Grid>
					<Grid item xs={3} style={{ textAlign: 'center' }}>
						<span style={{ lineHeight: '100px', textAlign: 'center' }}>درخواست های مشاوره :</span>
						<span className={classes.userInfoValue}>0</span>
					</Grid>
					<Grid item xs={3} style={{ textAlign: 'center' }}>
						<span style={{ lineHeight: '100px', textAlign: 'center' }}>امتیاز شما تا کنون:</span>
						<span className={classes.userInfoValue} style={{ background: '#FECF1E', color: '#3D2294' }}>0</span>
					</Grid>
				</Grid>
			</Hidden>
			<Hidden xlUp lgUp>
				<Grid container className={classes.userInfo} id="user_info">
					<Grid item xs={8} style={{ textAlign: 'right', padding: '20px' }}>
						<span style={{ lineHeight: '20px' }}>درخواست های ثبت شده :</span>
						<span>0</span>
						<br />
						<span style={{ lineHeight: '20px' }}>درخواست های به نتیجه رسیده :</span>
						<span>0</span>
						<br />
						<span style={{ lineHeight: '20px' }}>درخواست های مشاوره :</span>
						<span>0</span>
					</Grid>
					<Grid item xs={4} style={{ textAlign: 'center', padding: '15px' }}>
						<span className={classes.userInfoValue} style={{ background: '#FECF1E', color: '#3D2294' }}>0</span>
						<br />
						<span style={{ lineHeight: '30px' }}>امتیاز شما تا کنون</span>
					</Grid>
				</Grid>
			</Hidden>
		</>
	)
}
export default SubMenu
